import React from 'react';
import { WppGrid } from 'buildingBlocks';
import { bulkUploaderStyles } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/style';
import BulkUploaderTextArea from './BulkUploaderTextArea';

const { memberFieldLabel, uploadFieldLabel } = bulkUploaderStyles;

type Props = {
  setBulkFlightIds: (ids: Array<number>) => void
  shouldShowFileErr: boolean
};

const InputObjectIdsTab = (props: Props) => {
  const { setBulkFlightIds, shouldShowFileErr } = props;

  return (
    <WppGrid container fullWidth style={memberFieldLabel}>
      <WppGrid container item all={24} style={uploadFieldLabel}>
        <BulkUploaderTextArea
          setBulkFlightIds={setBulkFlightIds}
          shouldShowFileErr={shouldShowFileErr}
        />
      </WppGrid>
    </WppGrid>
  );
};

export default InputObjectIdsTab;
